import { BUTTON_SIZE, BUTTON_TYPE, DSButton } from '@repo/design-system/index'
import { useEffect, useState } from 'react'
import {
  ILoginPayload,
  OAUTH_GRANT_TYPE,
  PRODUCT_TYPE,
  SOCIAL_LOGIN_PROVIDER,
  loginWithProvider,
} from '../../modules/auth'
import useAppRouter from '../../modules/hooks/common/useAppRouter'
import { DEFAULT_LOCALE, LOCALE_KEY } from '../../modules/i18n/config'
import useTranslation from '../../modules/i18n/useTranslation'
import { DATA_REF_KEY } from '../../modules/ids/e2e/student'
import { FACEBOOK_APP_ID, SOCIAL_LOGIN_PREFIX } from '../../modules/vars'
import { useBasicPopup } from '../basic/popup/BasicPopup'
import SignUpLogo from '../common/SignUpLogo'

interface Response {
  status: 'connected' | 'not_authorized' | 'unknown'
  authResponse: null | AuthResponse
}

interface AuthResponse {
  accessToken: string
  expiresIn: number
  signedRequest: string
  userId: string
  data_access_expiration_time: number
  graphDomain: string
}

interface FacebookLoginBtnProps {
  size?: string
  text?: string
  clx?: string
}

const FacebookLoginBtn = ({ size, text, clx }: FacebookLoginBtnProps) => {
  const router = useAppRouter()
  const { locale, isLocaleKO } = useTranslation()
  const basicPopup = useBasicPopup()
  useEffect(() => {
    setFBAsyncInit()
    loadSdkAsynchronously()
  }, [])

  function setFBAsyncInit() {
    ;(window as any).fbAsyncInit = () => {
      ;(window as any).FB.init({
        version: `v15.0`,
        appId: FACEBOOK_APP_ID,
        xfbml: true,
        cookie: true,
        status: true,
      })
    }
  }

  function loadSdkAsynchronously() {
    ;((d, s, id) => {
      const element = d.getElementsByTagName(s)[0]
      const fjs = element as Element
      let js = element as any
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = `https://connect.facebook.net/en_US/sdk.js`
      fjs.parentNode!.insertBefore(js, fjs)
    })(document, 'script', 'facebook-jssdk')
  }

  const checkLogin = () => {
    basicPopup.show({
      id: 'alert_date_select',
      overlayClose: true,
      title: isLocaleKO ? '페이스북 로그인 서비스 종료 안내' : 'Service Termination Announcement',
      maxW: 600,
      bodyPb: 24,
      body: (
        <div>
          <div className="Body1-16Md">
            {isLocaleKO
              ? '페이스북 시스템의 잦은 오류로 인해 2024년 5월 8일 이후로 페이스북 로그인 서비스가 종료되었습니다. 로그인을 희망하신다면 고객센터에 문의 주세요. 감사합니다.'
              : 'The Facebook login service will no longer be provided after May 8, 2024. If you wish to log in, please contact the customer service center.'}
          </div>
          <div className="mt-[32px]">
            <a
              href={
                isLocaleKO
                  ? 'https://ringleplus.channel.io/support-bots/98756'
                  : 'https://ringleplus.channel.io/support-bots/98803'
              }
              target="_blank"
              rel="noreferrer"
            >
              <DSButton type={BUTTON_TYPE.SOLID} size={BUTTON_SIZE.LG} onClick={null}>
                <DSButton.Label>{isLocaleKO ? '고객센터 문의하기' : 'Contact the Ringle Team'}</DSButton.Label>
              </DSButton>
            </a>
          </div>
        </div>
      ),
    })
    // ;(window as any).FB.getLoginStatus((checkResponse: Response) => {
    //   ;(window as any).FB.login(
    //     (checkResponse: Response) => {
    //       responseFacebook(checkResponse)
    //     },
    //     { scope: 'email' }
    //   )
    // })
  }
  const [FBResponse, setFBResponse] = useState(false)

  const responseFacebook = async (response) => {
    if (response.status === 'connected') {
      const { authResponse } = response
      const access_token = authResponse.accessToken
      const payload: Omit<ILoginPayload, 'google_token_type'> = {
        grant_type: OAUTH_GRANT_TYPE.PASSWORD,
        username: SOCIAL_LOGIN_PREFIX + SOCIAL_LOGIN_PROVIDER.FACEBOOK,
        password: access_token,
        locale: locale == LOCALE_KEY ? DEFAULT_LOCALE : locale,
        product_type: PRODUCT_TYPE.PLUS,
      }
      await loginWithProvider(router, payload, isMobile, null, SOCIAL_LOGIN_PROVIDER.FACEBOOK)
      setFBResponse(true)
    }
  }

  // useEffect(() => {
  //   if (FBResponse) {
  //     checkLogin()
  //   }
  // }, [FBResponse])

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])
  return (
    <SignUpLogo
      clx={clx ? clx : 'mx-4'}
      type="facebook"
      size={size ? 'lg' : 'sm'}
      text={text}
      onClick={checkLogin}
      dataRef={DATA_REF_KEY.btn_facebook}
    />
  )
}

export default FacebookLoginBtn
